import get from 'lodash/get';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, map, catchError, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BasicConfigService {
  constructor(private http: HttpClient, private store: Store) {}

  private basicConfig: { [key: string]: any } = {};
  async initConfig() {
    return lastValueFrom(
      this.http.get('/common/getFrontendSystemConfig').pipe(
        // delay(10000),
        map((res: any) => {
          this.basicConfig = res || {};
          return res;
        }),
        catchError(error => {
          console.error('Failed to load config from server, loading local config instead.', error);
          return this.loadLocalConfig();
        })
      )
    );
  }

  private loadLocalConfig() {
    return lastValueFrom(
      this.http.get('assets/config.json').pipe(
        map((res: any) => {
          this.basicConfig = res || {};
          return res;
        })
      )
    );
  }

  // async initConfig() {
  //   return this.http.get('/common/getFrontendSystemConfig').pipe(
  //     // delay(5000), // 模拟慢接口
  //     catchError((error: HttpErrorResponse) => {
  //       return this.http.get('assets/config.json').pipe(
  //         switchMap((localConfig: any) => {
  //           return of({ frontendSystemConfig: localConfig });
  //         })
  //       );
  //     }),

  //     map((res: any) => {
  //       this.basicConfig = res.frontendSystemConfig || {};
  //       return res;
  //     })
  //   );
  // }

  get<T>(key: string): T {
    return get(this.basicConfig, key);
  }
  // 设置配置
  setConfig(key: string, value: any) {
    this.basicConfig[key] = value;
  }
}
